module.exports = __webpack_public_path__ + "static/img/model4-2.3808468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ppt/model4-2.png
// module id = eBkt
// module chunks = 4